// extracted by css-extract-rspack-plugin
export default {"progressBar":"ProgressBar_progressBar__BgSUo","fadeIn":"ProgressBar_fadeIn__fo6Rz"};